import { _ as _extends, a as _defineProperty } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default, { useState, useEffect, useContext, Component } from 'react';
import Content from './content.js';
export { default as Content } from './content.js';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
export { T as ThemeContext } from './ThemeContext-e1f446be.js';
export { default as Button } from './button.js';
import './SearchIcon-835318c0.js';
import { k as IconCircleClose, V as InfoFilled } from './index-56745294.js';
export { a1 as Icons } from './index-56745294.js';
export { default as ChevronLeftSVG } from './chevronLeftSVG.js';
export { default as ChevronRightSVG } from './chevronRightSVG.js';
export { default as ChevronRightThinSVG } from './chevronRightThinSVG.js';
export { default as ChevronUpThinSVG } from './chevronUpThinSVG.js';
import './IconQuestionFilled-146e7ca3.js';
import './icon-tick-filled-3149e72f.js';
export { default as MinusCircle } from './minusCircle.js';
export { default as PlusCircle } from './plusCircle.js';
import './Photos-5eb9c552.js';
export { default as LoadingSpinner } from './loadingSpinner.js';
export { default as StepsButton } from './stepsButton.js';
import { F as FeedbackTooltip } from './FeedbackTooltip-fe34aaac.js';
export { F as FeedbackTooltip, V as ViewportContext, w as withViewportProvider } from './FeedbackTooltip-fe34aaac.js';
import '@tippy.js/react';
export { default as Theme } from './theme.js';
import './helpers-1066b771.js';
export { default as Tooltip } from './tooltip.js';
export { default as TooltipAnchor } from './tooltipAnchor.js';
export { default as InputIcon } from './inputIcon.js';
export { a as Input } from './Input-5d5bcc53.js';
export { default as LegacyRadioControl } from './legacyRadioControl.js';
import PropTypes from 'prop-types';
export { default as Select } from './select.js';
export { default as Toggle } from './toggle.js';
export { default as ColourSelect } from './colourSelect.js';
export { default as Header } from './header.js';
export { default as LogoAffiliate } from './logoAffiliate.js';
export { default as LogoBuyer } from './logoBuyer.js';
export { default as LogoMake } from './logoMake.js';
export { default as LogoMotorway } from './logoMotorway.js';
export { default as LogoPress } from './logoPress.js';
import 'react-dom';
export { default as ImageGallery } from './imageGallery.js';
export { default as DotList } from './dotList.js';
export { default as SpecList } from './specList.js';
export { default as TickList } from './tickList.js';
export { default as Modal } from './modal.js';
export { default as Portal } from './portal.js';
export { default as Dialog } from './dialog.js';
export { default as ConfirmModal } from './confirmModal.js';
export { default as Sidebar } from './sidebar.js';
export { default as Spacer } from './spacer.js';
export { default as StarRating } from './starRating.js';
export { default as Tag } from './tag.js';
export { default as Title } from './title.js';
export { default as MultiplePhotoInput } from './multiplePhotoInput.js';
export { default as PhotoInput } from './photoInput.js';
export { default as AffiliateHeader } from './affiliateHeader.js';
import './texts-3c1c08f5.js';
import 'i18n-react';
export { default as VehicleFooter } from './vehicleFooter.js';
import 'react-router-dom';
export { default as VehicleHeader } from './vehicleHeader.js';
export { default as VrmBadge } from './vrmBadge.js';
export { M as MultiSelect, P as PrefixInput } from './MultiSelect-5223f404.js';
export { default as LabelContainer } from './labelContainer.js';
export { default as Textarea } from './textarea.js';

const Checkbox = props => {
  const [wrapperRef, setWrapperRef] = useState(null);
  const {
    className,
    id,
    label,
    labelProps,
    inputProps,
    required,
    intent,
    feedbackTooltip = {}
  } = props;
  if (!id) {
    console.warn(`Checkbox element with the label "${label}" needs an ID attribute to associate label with the input`);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('mw-checkbox', className, {
      'mw-intent-error': intent === 'error'
    })
  }, /*#__PURE__*/React__default.createElement(FeedbackTooltip, {
    intent: intent,
    appendTo: wrapperRef,
    content: feedbackTooltip.content,
    placement: feedbackTooltip.placement,
    placementFlipped: feedbackTooltip.placementFlipped,
    fillWidth: feedbackTooltip.fillWidth
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: setWrapperRef,
    className: 'mw-checkbox-box'
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    type: "checkbox",
    id: id,
    required: required
  })), label && /*#__PURE__*/React__default.createElement("label", _extends({}, labelProps, {
    htmlFor: id
  }), label))));
};
Checkbox.defaultProps = {
  required: true
};
Checkbox.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelProps: PropTypes.object,
  inputProps: PropTypes.object,
  iconProps: PropTypes.object,
  errorProps: PropTypes.object,
  required: PropTypes.bool
};

const COOKIE_NAME = 'cookieConsent';
const getCookieValue = name => {
  let value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return value ? value.pop() : '';
};
const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};
const CookieConsentContext = /*#__PURE__*/React__default.createContext([false, () => {}]);
const CookieConsentProvider = ({
  children
}) => {
  const [accepted, setAccepted] = useState(false);
  const handleAccept = () => {
    setAccepted(true);
    setCookie(COOKIE_NAME, 'true', 365);
  };

  // componentDidMount
  useEffect(() => {
    if (getCookieValue(COOKIE_NAME) === 'true') {
      setAccepted(true);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(CookieConsentContext.Provider, {
    value: [accepted, handleAccept]
  }, children);
};
const withCookieConsentProvider = WrappedComponent => {
  const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const WithCookieConsentProvider = props => /*#__PURE__*/React__default.createElement(CookieConsentProvider, null, /*#__PURE__*/React__default.createElement(WrappedComponent, props));
  WithCookieConsentProvider.displayName = `WithCookieConsentProvider(${getDisplayName(WrappedComponent)})`;
  return WithCookieConsentProvider;
};

var styles = {"wrapper":"CookieConsentBanner_wrapper__1END0","cookie":"CookieConsentBanner_cookie__1E1La","themeDark":"CookieConsentBanner_themeDark__6iyB4","component":"CookieConsentBanner_component__1jyLX","dismiss":"CookieConsentBanner_dismiss__2SmqY","desktopOnly":"CookieConsentBanner_desktopOnly__3TgXF","mobileOnly":"CookieConsentBanner_mobileOnly__32V3T"};

const CookieConsentBanner = ({
  appTitle,
  anchorUrl,
  ...props
}) => {
  const [isVisible, setVisible] = useState(false);
  const {
    theme
  } = useContext(ThemeContext);
  const [acceptedCookieValue, writeAcceptedToCookie] = useContext(CookieConsentContext);

  // componentDidMount
  useEffect(() => {
    if (!acceptedCookieValue) {
      setVisible(true);
    }
  }, []);

  // when receives new cookie value from context
  useEffect(() => {
    if (acceptedCookieValue) {
      setVisible(false);
    }
  }, [acceptedCookieValue]);
  const handleDismiss = () => {
    setVisible(false);
    writeAcceptedToCookie();
    props.onDismiss();
  };
  return isVisible ? /*#__PURE__*/React__default.createElement(Content, {
    element: "section",
    center: true,
    wrapper: {
      className: cx(styles.wrapper, {
        [styles.themeDark]: theme === 'dark'
      })
    },
    className: styles.component
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.desktopOnly
  }, `${appTitle} uses cookies. Find out more `, /*#__PURE__*/React__default.createElement("a", {
    href: anchorUrl,
    className: "mw-link mw-link-white"
  }, 'here'), '.'), /*#__PURE__*/React__default.createElement("div", {
    className: styles.mobileOnly
  }, `${appTitle} uses `, /*#__PURE__*/React__default.createElement("a", {
    href: anchorUrl,
    className: "mw-link mw-link-white"
  }, 'cookies'), '.'), /*#__PURE__*/React__default.createElement(IconCircleClose, {
    className: styles.dismiss,
    onClick: handleDismiss
  })) : null;
};
CookieConsentBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  appTitle: PropTypes.string,
  anchorUrl: PropTypes.string
};
CookieConsentBanner.defaultProps = {
  onDismiss: () => {}
};

class Slider extends Component {
  constructor(props) {
    super(props);

    // Clearable min/max should allow going over the intended min/max to set for clearing
    _defineProperty(this, "slider", /*#__PURE__*/React__default.createRef());
    _defineProperty(this, "fromEl", /*#__PURE__*/React__default.createRef());
    _defineProperty(this, "toEl", /*#__PURE__*/React__default.createRef());
    _defineProperty(this, "generateEvents", event => {
      const events = {
        'mousemove': this.touchDevice ? 'touchmove' : 'mousemove',
        'mouseup': this.touchDevice ? 'touchend' : 'mouseup'
      };
      return events[event];
    });
    _defineProperty(this, "serializeValue", value => {
      // N -> %
      return (value - this.state.bufferedMin) / (this.state.bufferedMax - this.state.bufferedMin) * 100;
    });
    _defineProperty(this, "handlePointerDown", e => {
      this.setState({
        dragging: e.target.getAttribute('dir')
      });
    });
    _defineProperty(this, "handlePointerUp", () => {
      if (this.state.dragging && this.props.onChange) {
        let {
          from,
          to
        } = this.state;
        if (this.props.clearMin && from === this.state.bufferedMin) from = null;
        if (this.props.clearMax && to === this.state.bufferedMax) to = null;
        this.props.onChange(from, to);
      }
      this.setState({
        dragging: null,
        dxFrom: null,
        dxTo: null
      });
    });
    _defineProperty(this, "handlePointerMove", e => {
      e.stopPropagation();
      if (this.state.dragging) {
        var _e$touches, _e$touches$;
        const slider = this.slider.current;
        const clientX = ((_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : (_e$touches$ = _e$touches[0]) === null || _e$touches$ === void 0 ? void 0 : _e$touches$.clientX) || e.clientX;
        const sliderRect = slider.getBoundingClientRect();
        const dx = clientX - sliderRect.left;
        const dxPercent = dx / sliderRect.width;
        let cursorVal = Math.max(this.state.bufferedMin, Math.min(this.state.bufferedMax, this.state.bufferedMin + Math.round(dxPercent * (this.state.bufferedMax - this.state.bufferedMin))));

        // Snap cursorVal to nearest increment
        cursorVal -= cursorVal % this.state.increment;
        if (this.state.dragging === 'from') {
          if (cursorVal < this.state.to) this.setState({
            from: cursorVal
          });
        } else if (this.state.dragging === 'to') {
          if (cursorVal > this.state.from) this.setState({
            to: cursorVal
          });
        } else {
          // Range shift
          let dxFrom = this.state.dxFrom;
          let dxTo = this.state.dxTo;
          if (dxFrom === null) {
            dxFrom = cursorVal - this.state.from;
            dxTo = this.state.to - cursorVal;
            this.setState({
              dxFrom,
              dxTo
            });
          }
          const from = cursorVal - dxFrom;
          const to = cursorVal + dxTo;
          if (from >= this.state.bufferedMin && to <= this.state.bufferedMax) this.setState({
            from,
            to
          });
        }
      }
    });
    _defineProperty(this, "quickJump", async e => {
      if (e.clientX && e.currentTarget.isEqualNode(e.target)) {
        // `clientX` - Mobile is too imprecise for this
        e.persist(); // So we can pass to `handlePointerMove`

        const $el = this.fromEl.current || this.toEl.current;
        const {
          left
        } = $el.getBoundingClientRect();
        await this.setState({
          dragging: e.clientX < left ? 'from' : 'to'
        });
        this.handlePointerMove(e);
        requestAnimationFrame(() => this.setState({
          dragging: null,
          dxFrom: null,
          dxTo: null
        }));
      }
    });
    const bufferedMin = props.min - (props.clearMin && !props.skipMin ? props.increment || 1 : 0);
    const bufferedMax = props.max + (props.clearMax && !props.skipMax ? props.increment || 1 : 0);
    this.touchDevice = typeof window !== 'undefined' && 'ontouchstart' in window;
    this.state = {
      from: props.from !== null ? props.from : bufferedMin,
      to: props.to !== null ? props.to : bufferedMax,
      bufferedMin,
      bufferedMax,
      increment: props.increment || 1,
      dragging: null,
      dxFrom: null,
      dxTo: null
    };
  }
  componentDidMount() {
    document.addEventListener(this.generateEvents('mousemove'), this.handlePointerMove);
    document.addEventListener(this.generateEvents('mouseup'), this.handlePointerUp);
  }
  componentWillUnmount() {
    document.removeEventListener(this.generateEvents('mousemove'), this.handlePointerMove);
    document.removeEventListener(this.generateEvents('mouseup'), this.handlePointerUp);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.from !== this.props.from || prevProps.to !== this.props.to) this.setState({
      from: this.props.from !== null ? this.props.from : this.state.bufferedMin,
      to: this.props.to !== null ? this.props.to : this.state.bufferedMax
    });
  }
  render() {
    const {
      bufferedMax,
      bufferedMin,
      from,
      increment,
      to
    } = this.state;
    const {
      clearMax,
      clearMin,
      display,
      handleClassName,
      rangeClassName,
      skipMax,
      skipMin,
      sliderClassName,
      tooltipClassName,
      disabledFrom,
      disabledTo
    } = this.props;
    const fromPercent = this.serializeValue(from);
    const toPercent = this.serializeValue(to);
    const rangePercent = toPercent - fromPercent;
    const clearedMin = clearMin && from === bufferedMin;
    const clearedMax = clearMax && to === bufferedMax;
    const isDisabledOnePoint = disabledFrom || disabledTo;
    // when we disable either from or to range we dont need move ranger

    const rangeEvents = isDisabledOnePoint ? {} : {
      onMouseDown: this.handlePointerDown,
      onTouchStart: this.handlePointerDown
    };
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      ref: this.slider,
      className: cx('mw-slider-wrapper', sliderClassName, {
        'mw-slider-wrapper-left': disabledFrom,
        'mw-slider-wrapper-right': disabledTo
      }),
      onClick: this.quickJump
    }, /*#__PURE__*/React__default.createElement("div", _extends({
      dir: "range",
      className: cx('mw-range-slider', rangeClassName),
      style: {
        left: `${fromPercent}%`,
        width: `${rangePercent}%`
      }
    }, rangeEvents)), !disabledFrom && /*#__PURE__*/React__default.createElement("span", {
      dir: "from",
      ref: this.fromEl,
      className: cx('mw-handle-slider', handleClassName),
      style: {
        left: `${fromPercent}%`
      },
      onMouseDown: this.handlePointerDown,
      onTouchStart: this.handlePointerDown
    }), !disabledTo && /*#__PURE__*/React__default.createElement("span", {
      dir: "to",
      ref: this.toEl,
      className: cx('mw-handle-slider', handleClassName),
      style: {
        left: `${toPercent}%`
      },
      onMouseDown: this.handlePointerDown,
      onTouchStart: this.handlePointerDown
    })), /*#__PURE__*/React__default.createElement("div", {
      className: cx('mw-tooltip-slider', tooltipClassName)
    }, clearedMin ? '<' : '', !disabledFrom && (display ? display(from + (clearedMin && !skipMin ? increment : 0), 'start') : from + (clearedMin && !skipMin ? increment : 0)), !isDisabledOnePoint && /*#__PURE__*/React__default.createElement("span", null, "\xA0-\xA0"), !disabledTo && (display ? display(to - (clearedMax && !skipMax ? increment : 0), 'end') : to - (clearedMax && !skipMax ? increment : 0)), clearedMax ? '+' : ''));
  }
}

var styles$1 = {"component":"InfoBanner_component__OKFBF","visible":"InfoBanner_visible__3Nmb8","content":"InfoBanner_content__2cjB2","infoBox":"InfoBanner_infoBox__qLXYR","body":"InfoBanner_body__1CWGM","title":"InfoBanner_title__sl28x","icon":"InfoBanner_icon__3NpPO","close":"InfoBanner_close__2RYk6","text":"InfoBanner_text__NrLTx"};

const InfoBanner = ({
  children,
  className,
  titleClassName,
  visibleClassName,
  icon = /*#__PURE__*/React__default.createElement(InfoFilled, null),
  id,
  interval = 86400000,
  // 24 hours
  title
}) => {
  const [isVisible, setVisible] = useState(false);
  useEffect(() => {
    const status = JSON.parse(window.localStorage.getItem(id)) || {};
    const visible = !status.interval || Date.now() >= status.interval;
    setVisible(visible);
  }, [id]);
  return /*#__PURE__*/React__default.createElement(Content, {
    className: styles$1.content,
    wrapper: {
      className: cx('mw-infoBox-wrapper', styles$1.component, {
        [styles$1.visible]: isVisible,
        [visibleClassName]: isVisible
      })
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.infoBox
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cx(styles$1.body, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cx(styles$1.title, titleClassName)
  }, icon && /*#__PURE__*/React__default.cloneElement(icon, {
    className: cx(styles$1.icon, icon.props.className)
  }), title, /*#__PURE__*/React__default.createElement(IconCircleClose, {
    className: styles$1.close,
    onClick: () => {
      setVisible(false);
      window.localStorage.setItem(id, JSON.stringify({
        id,
        interval: Date.now() + interval
      }));
    }
  })), children && /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.text
  }, children))));
};
InfoBanner.propTypes = {
  id: PropTypes.string.isRequired,
  interval: PropTypes.number
};
InfoBanner.defaultProps = {
  title: '',
  children: null
};

export { Checkbox, CookieConsentBanner, CookieConsentContext, InfoBanner, Slider, withCookieConsentProvider };
